import { useAppSidebar } from "shared/lib/app-sidebar/app-sidebar-store"

export function useHeaderMenuButtonModel() {
  const { isOpen, toggleOpen } = useAppSidebar()

  return {
    isOpen,
    onClick: toggleOpen
  }
}
